export default __webpack_public_path__ + "static/media/f85d6954cfac671236e2a486bf10055c.321b1792.svg";